module.exports = __webpack_public_path__ + "img/warning2-dent-red.b06f899e.svg";